import { render, staticRenderFns } from "./CargosResumen.vue?vue&type=template&id=143fe5c6&"
import script from "./CargosResumen.vue?vue&type=script&lang=js&"
export * from "./CargosResumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports